import type { CSSProperties } from "react";

interface IconProps {
  name: string;
  className?: string;
  filled?: boolean;
  size?: number;
  onClick?: () => void;
}

export function Icon({ name, className = "", filled = false, size, onClick }: IconProps) {
  const style: CSSProperties = {
    fontVariationSettings: filled ? "'FILL' 1" : "'FILL' 0",
    ...(size && { fontSize: `${size}px` }),
  };

  return (
    <span
      className={`material-symbols-outlined ${className}`}
      style={style}
      onClick={onClick}
      aria-hidden="true"
    >
      {name}
    </span>
  );
}
